<template>
  <div class="navbar">
    <navmenu />
    <el-menu mode="horizontal" @select="handleSelect" background-color="#3c3e42" text-color="#dfe1e3"
      class="nav-bar-menu right-menu">
      <span class="tenant-name" v-if="user.tenantId">{{ tenantName }}</span>
      <el-submenu index="tenant" v-else-if="accounts.length > 1">
        <template slot="title">
          <div class="tenant">
            {{ tenantName }}
          </div>
        </template>
        <div class="tenant-menu">
          <el-menu-item v-for="(item, i) in accounts" :key="i" :index="item.name + '$%&' + item.id">
            {{ item.name }}
          </el-menu-item>
        </div>
      </el-submenu>
      <!-- <svg-icon
        class="message-icon international right-menu-item"
        icon-class="operation-log"
      /> -->
      <!-- <svg-icon
        class="message-icon international right-menu-item"
        icon-class="QR-code"
      /> -->
      <!-- <svg-icon
        class="message-icon international right-menu-item"
        icon-class="msg-ico"
      /> -->
      <!-- <div class="help" @click="help">帮助</div> -->
      <el-submenu index="user" class="user-submenu">
        <template slot="title">
          <div class="avatar-wrapper">
            <img src="../../assets/image/default-head.png" class="user-avatar" v-if="!avatarImage" />
            <img :src="avatarImage" class="user-avatar" v-else />
            <span class="user-name">{{ userName }}</span>
            <i class="el-icon-arrow-down" />
          </div>
        </template>
        <div class="user-menu">
          <el-menu-item index="personal">
            <svg-icon icon-class="user" />个人中心
          </el-menu-item>
          <!-- <el-menu-item index="switch">
            <svg-icon icon-class="switch" />切换用户
          </el-menu-item> -->
          <el-menu-item index="logout">
            <svg-icon icon-class="logout" />退出登录
          </el-menu-item>
        </div>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import Navmenu from "./Navmenu";
import { getTenantName, setTenantId, getTenantId } from "@/utils/authStore";
import { getMyProfileTenants } from "@/http/api/profile";
import Bus from "@/utils/bus";

export default {
  components: { Navmenu },
  data() {
    return {
      userName: "",
      avatarImage: "",
      tenantName: "企业云平台",
      tenantId: "",
      loginId: "",
      user: {},
      accounts: [],
    };
  },
  methods: {
    help() { },
    menuCommand(e) {
      if (e == "exit") {
        this.$store.dispatch("LogOut");
        this.$router.replace("/login");
        return;
      }
      this.$router.push({ name: e });
    },
    handleSelect(key, keyPath) {
      if (key == "logout") {
        this.$store.dispatch("LogOut");
        this.$router.replace("/login");
      } else if (keyPath[0] == "tenant") {
        let arr = key.split("$%&");
        if (this.tenantName != arr[0]) {
          if (arr[0] == "企业云平台") {
            setTenantId(null);
          } else {
            setTenantId(arr[1]);
          }
          if (arr[1]) {
            this.$store.commit(
              "SET_GENERATEUPDATESETTONGSPARAMS",
              `?providerName=T&providerKey=${arr[1]}`
            );
          } else {
            this.$store.commit(
              "SET_GENERATEUPDATESETTONGSPARAMS",
              `?providerName=G`
            );
          }
          this.tenantName = arr[0];
          this.$message.success({
            message: `已切换至${this.tenantName}`,
            showClose: true,
          });
          this.$parent.reload();
        }
      } else {
        this.$router.push({ name: key });
      }
    },
    getTenants() {
      getMyProfileTenants().then((res) => {
        this.accounts = res.result;
        if (getTenantId()) {
          this.accounts.map((item) => {
            if (item.id == getTenantId()) {
              this.tenantName = item.name;
            }
          });
        } else {
          this.tenantName = "企业云平台";
        }
      });
    },
  },
  mounted() {
    this.tenantName = getTenantName();
    this.user = this.$store.getters.user;
    this.userName = this.$store.getters.name;
    if (this.user) {
      this.avatarImage = this.user.photoUrl;
    }
    if (!this.user.tenantId) {
      this.getTenants();
    }
    Bus.$on("TenantsChange", this.getTenants);
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
  position: fixed;
  padding: 0 20px;
  width: 100%;
  height: 48px;

  line-height: 48px;
  background: #3c3e42;
  z-index: 999;

  .right-menu {
    display: flex;
    align-items: center;

    height: 100%;
    font-size: 14px;
    color: #c1c6c8;

    &::after,
    &::before {
      display: none;
    }

    .tenant-name {
      margin-right: 10px;
      min-width: 80px;
      white-space: nowrap;
      /*内容超宽后禁止换行显示*/
      overflow: hidden;
      /*超出部分隐藏*/
      text-overflow: ellipsis;
      /*文字超出部分以省略号显示*/
    }

    .help {
      display: flex;
      align-items: center;
      margin-left: 14px;
      margin-right: 16px;
      min-width: 30px;

      .svg-icon {
        margin-right: 8px;
      }
    }

    ::v-deep.user-submenu {
      margin-right: 20px;

      .el-submenu__title {
        padding-right: 0;

        .avatar-wrapper {
          display: flex;
          align-items: center;

          .user-avatar {
            width: 25px;
            height: 25px;
            vertical-align: middle;
            border-radius: 50%;
          }

          .user-name {
            vertical-align: middle;
            margin-left: 8px;
          }

          .el-icon-arrow-down {
            vertical-align: middle;
            margin-left: 5px;
            margin-right: 0;
          }
        }
      }
    }
  }
}

.user-menu {
  .el-menu-item.is-active {
    color: $--color-primary !important;
  }
}

.avatar-wrapper {
  display: flex;
  align-items: center;

  .user-avatar {
    width: 25px;
    height: 25px;
    vertical-align: middle;
    border-radius: 50%;
  }

  .user-name {
    vertical-align: middle;
    margin-left: 8px;
  }

  .el-icon-arrow-down {
    vertical-align: middle;
    margin-left: 5px;
    margin-right: 0;
  }
}
</style>
